const money = new Intl.NumberFormat('en-BD', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

// `|| 0`: a zero (or a value that rounds to it) never prints as "-0.00".
export const formatMoney = (n: number) => `৳${money.format(Math.round(n * 100) / 100 || 0)}`

export const formatTime = (iso: string) =>
  new Date(iso).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })

export const formatDateTime = (iso: string) =>
  new Date(iso).toLocaleString('en-GB', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })

export const initials = (name: string) =>
  name
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase()

const qty = new Intl.NumberFormat('en-BD', { maximumFractionDigits: 3 })

export const formatQty = (n: number) => qty.format(n)

/** Whole days from today to an expiry date (negative once expired), by the device's calendar. */
export const daysUntil = (iso: string) => {
  const day = (d: Date) => Date.UTC(d.getFullYear(), d.getMonth(), d.getDate())
  return Math.round((day(new Date(iso)) - day(new Date())) / 86_400_000)
}

export const formatDate = (iso: string) => new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
